/**
 * verify dataLayer exists, then push to it using GA's push method
 * @param {Object<string,any>} data 
 */
export default function push(data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
}
